export const LOG_LEVELS = {
  ERROR: "ERROR",
  WARNING: "WARN",
  INFO: "INFO"
}
